export default {
    visitorView: 'View Visitor profile',
    visitorInfo: 'Profile',
    citizenIdPassportId: 'Citizen ID / Passport ID',
    visitorName: 'Name',
    visitorSurname: 'Surname',
    visitorGender: 'Gender',
    visitAt: 'Visit At',
    emailAddress: 'Email address',
    phoneNumber: 'Phone number',
    operator: 'Operator (Employee ID)',
    visitorStatus: 'Visitor Status',
    visitorActive: 'Active',
    visitorDeactive: 'Deactive',
    activityLog: 'Activity log',
    male: 'Male',
    female: 'Female',
    others: 'Others'
}
